import React from "react";
import styles from "./CustomButton.module.scss";

interface CustomButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    children: React.ReactNode;
}

const CustomButton: React.FC<CustomButtonProps> = ({ children, className, ...props }) => {
    return (
        <button
            className={`${styles.customButton} ${className || ""}`.trim()}
            {...props}
        >
            {children}
        </button>
    );
};

export default CustomButton;
